const Layout = () => System.import('../../Shared/Layout/App/View/Layout.vue');
const Venda = () => System.import('../App/View/Venda.vue');
const Pedido = () => System.import('../App/View/Pedido.vue');
const DadosPedido = () => System.import('../App/View/DadosPedido.vue');

export const VendaRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      {path: 'venda', component: Venda, name: 'venda', meta: {auth: true}},
      {path: 'venda/pedido', component: Pedido, name: 'venda-pedido', meta: {auth: true}},
      {path: 'venda/pedido/dados/:id', component: DadosPedido, name: 'venda-dados-pedido', meta: {auth: true, acao: 'consulta'}},
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/Venda/Rotas/Routes.js